import React  from "react";
import PropTypes from "prop-types";
import InputMask from "react-input-mask";
import cx from "classnames";
import {useTranslation} from "react-i18next";

const DEFAULT_COUNTRY = { code: '998', mask: '##-###-####' };
const FALLBACK_PHONE_MASK = '##########';

const InputMaskS1 = ({ className, label, mask, country, readOnly, disabled, placeholder, type, size, field, form: { touched, errors }, ...props }) => {
  const classes = cx(
      'form-field',
      touched[field.name] && errors[field.name] && 'form-field--error',
      `form-field--${size}`,
      disabled && `form-field--disabled`,
      field.value && 'form-field--active',
      className
  );

  InputMaskS1.propTypes = {
    label: PropTypes.string,
    type: PropTypes.oneOf(["text", "password", "number"]),
    className: PropTypes.string,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    size: PropTypes.oneOf(["default", "large", "small"]),
    mask: PropTypes.string,
    country: PropTypes.shape({
      code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      mask: PropTypes.string
    })
  };

  InputMaskS1.defaultProps = {
    label: "",
    placeholder: "",
    type: "text",
    className: null,
    readOnly: false,
    size: "default",
    mask: null,
    country: null
  };

  const {t} = useTranslation("main");

  const activeCountry = country && country.code
    ? { code: country.code, mask: country.mask && country.mask.includes('#') ? country.mask : FALLBACK_PHONE_MASK }
    : DEFAULT_COUNTRY;
  const finalMask = mask || `+${activeCountry.code} ${activeCountry.mask}`;

  return (
    <div className={classes}>
      {label && (
        <label className="form-field__label">{label}</label>
      )}
      <div className="input-group">
        <InputMask
            className="form-field__input"
            mask={finalMask}
            placeholder={placeholder}
            formatChars={{
              '#': '[0-9]',
              'A': '[A-Z]'
            }}
            readOnly={readOnly}
            {...{ placeholder, type }}
            {...field}
            {...props}
        />
        {touched[field.name] && errors[field.name] && (
            <div className="form-field__error">
              <span>{t(errors[field.name])}</span>
            </div>
        )}
      </div>
    </div>
  );
};

export default InputMaskS1;
